var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOnlyForAdults21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.689 13C26.689 20.1797 20.8687 26 13.689 26C6.50926 26 0.688965 20.1797 0.688965 13C0.688965 5.8203 6.50926 0 13.689 0C20.8687 0 26.689 5.8203 26.689 13Z",
    fill: "#E5243F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30524 16.875V15.149L11.3168 12.3637C11.5072 12.1812 11.6461 12.0224 11.7334 11.8875C11.8286 11.7526 11.8921 11.6336 11.9238 11.5304C11.9556 11.4193 11.9714 11.3162 11.9714 11.221C11.9714 11.0146 11.904 10.8559 11.7691 10.7448C11.6342 10.6258 11.4318 10.5663 11.162 10.5663C10.916 10.5663 10.6819 10.6337 10.4597 10.7686C10.2375 10.8956 10.063 11.0861 9.93599 11.34L7.81721 10.2806C8.11876 9.70924 8.57108 9.24502 9.17418 8.88792C9.77728 8.53082 10.5272 8.35227 11.4239 8.35227C12.0825 8.35227 12.6658 8.4594 13.1737 8.67366C13.6815 8.88792 14.0783 9.18947 14.364 9.57831C14.6497 9.96715 14.7925 10.4274 14.7925 10.9591C14.7925 11.2289 14.7568 11.4987 14.6854 11.7685C14.6219 12.0383 14.487 12.324 14.2807 12.6255C14.0743 12.9192 13.7688 13.2485 13.3641 13.6135L11.1025 15.6728L10.6621 14.6967H14.983V16.875H8.30524ZM16.7018 16.875V9.51879L17.904 10.6615H15.2734V8.54272H19.5109V16.875H16.7018Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnlyForAdults21);
export default __webpack_public_path__ + "static/media/icon-only-for-adults-21.5101dd8c181976c129cc772ca166fd07.svg";
export { ForwardRef as ReactComponent };